export default __webpack_public_path__ + "static/media/icon-qa.0bf49f7f.svg";